import { axiosInstance } from '@/lib/axios';
import { IntegrationsConfigurationPayload } from './types';

type Props = {
  companyId: string
  payload: IntegrationsConfigurationPayload
}

type UpdateConfigurationResponse = {
  message?: string
}

export function updateIntegrationsSettings({ companyId, payload }: Props) {
  return axiosInstance.post<UpdateConfigurationResponse>(`/api/${companyId}/configuration/saveIntegrationConfiguration`, payload);
}
